import { render, staticRenderFns } from "./exchangePrize.vue?vue&type=template&id=ec5cf7da&scoped=true&"
import script from "./exchangePrize.vue?vue&type=script&lang=js&"
export * from "./exchangePrize.vue?vue&type=script&lang=js&"
import style0 from "./exchangePrize.vue?vue&type=style&index=0&id=ec5cf7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5cf7da",
  null
  
)

export default component.exports